import { ApiBase } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { UserEntity } from './user-entity';

@inject(IHttpClient)
export class UserApi extends ApiBase {
    private _baseUrl: string = 'api/users';

    constructor(http: IHttpClient) {
        super(http);
    }

    public async getCurrentUser(linkToken?: string): Promise<UserEntity> {
        const response = await this.get(`${this._baseUrl}/current`, { linkToken });
        return UserEntity.fromDto(response.content);
    }

    public async add(entity: UserEntity): Promise<UserEntity> {
        const dto = entity.toDto();
        const response = await this.post(this._baseUrl, dto);
        return UserEntity.fromDto(response.content);
    }

    public async update(userId: string, entity: any): Promise<UserEntity> {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        const dto = entity.toDto();
        const response = await this.patch(this._baseUrl + '/' + userId, dto);
        return UserEntity.fromDto(response.content);
    }

    public async patchConsent(userId: string, patch: { acceptTerms?: boolean; acceptPrivacy?: boolean; emailMarketingConsent?: boolean; concurrency: string }): Promise<UserEntity> {
        const response = await this.patch(this._baseUrl + '/' + userId, patch);
        return UserEntity.fromDto(response.content);
    }

    public async beginLinkProvider(): Promise<string> {
        const response = await this.post(this._baseUrl + '/link-provider/begin', {});
        return (response.content as any).token as string;
    }

    public async deleteAccount(userId: string): Promise<void> {
        await this.delete(this._baseUrl + '/' + userId);
    }

    public async getById(userId: string): Promise<UserEntity> {
        const response = await this.get(this._baseUrl + '/' + userId);
        return UserEntity.fromDto(response.content);
    }

}
